var es = {
  TABLE_HEADER_SORT_ASC: 'Orden Ascendente',
  TABLE_HEADER_SORT_DESC: 'Orden Descendente',
  SEARCH_PLACEHOLDER: 'Buscar',
  TABLE_HEADER_FILTER_SEARCH_PLACEHOLDER: 'Buscar',
  TABLE_HEADER_FILTER_CLEAR_ALL: 'Borrar todo',
  TABLE_HEADER_FILTER_SEARCH_EMPTY_TABLE_TITLE: 'No se encontraron resultados',
  TABLE_HEADER_FILTER_SEARCH_EMPTY_TABLE_SUBTITLE: 'Prueba palabras clave más generales',
  TABLE_STATE_LOADING_RESULTS: 'Cargando resultados...',
  TABLE_STATE_EMPTY_SEARCH_TITLE: 'No se encontraron resultados para',
  TABLE_STATE_EMPTY_SEARCH_SUBTITLE: 'Inténtalo de nuevo con un término diferente.',
  TABLE_STATE_EMPTY_FILTER_TITLE: 'No hay resultados para mostrar',
  TABLE_STATE_EMPTY_FILTER_SUBTITLE: 'Inténtalo de nuevo con un filtro diferente',
  TABLE_STATE_EMPTY_FILTER_CTA: 'Borrar filtros',
  TABLE_HEADER_SELECT_ALL_TOOLTIP: 'Seleccionar todo',
  TABLE_HEADER_SELECTION_RESUME_COUNT: 'seleccionado.',
  TABLE_HEADER_SELECTION_RESUME_COUNT_plural: 'seleccionados.',
  TABLE_HEADER_SELECTION_RESUME_SELECT_ALL: 'Seleccionar los {{count}} items',
  TABLE_HEADER_SELECTION_RESUME_REMOVE_ALL: 'Anular selección',
  TABLE_STATE_EMPTY_WITHOUT_FILTERS: 'Aún no hay disponibles',
  TABLE_STATE_EMPTY_WITHOUT_FILTERS_SUBTITLE: 'La tabla no tiene información para mostrar',
  TABLE_STATE_ERROR_TITLE: 'Ocurrió un error',
  TABLE_STATE_ERROR_SUBTITLE: 'Haz clic en el botón para reintentar cargar nuevamente.',
  TABLE_STATE_ERROR_BUTTON_LABEL: 'Reintentar',
  TABLE_HEADER_ATTRIBUTES_FILTER_APPLY_BUTTON: 'Aplicar filtros',
  TABLE_HEADER_ATTRIBUTES_FILTER_SORT_BUTTON: 'Ordenar por',
  TABLE_HEADER_ATTRIBUTES_FILTER_SEARCH_PLACEHOLDER: 'Buscar atributo de usuario',
  TABLE_HEADER_ATTRIBUTES_CUSTOM_FIELDS_COUNT: 'etiquetas',
  TABLE_HEADER_ATTRIBUTES_CLEAR_ALL: 'Borrar todo',
  TABLE_HEADER_ATTRIBUTES_ATTRIBUTE_ITEM_SHOW_ALL: 'Ver todos',
  TABLE_HEADER_ATTRIBUTES_EMPTY_SEARCH_TITLE: 'No se encontraron resultados para',
  TABLE_HEADER_ATTRIBUTES_EMPTY_SEARCH_SUBTITLE: 'Inténtalo de nuevo con un término diferente.',
  TABLE_HEADER_ATTRIBUTES_DETAIL_BACK_BUTTON: 'Volver',
  TABLE_HEADER_ATTRIBUTES_DETAIL_SELECT_ALL: 'Seleccionar todo',
  TABLE_HEADER_ATTRIBUTES_DETAIL_REMOVE_SELECT_ALL: 'Deseleccionar todo',
  TABLE_PAGE_SIZE_SELECTOR_LABEL: 'Items por página:'
};
export default es;